<app-confirmation-popup #idle [title]="'Are you still there?'" [message]="idleWarning" (callAction)="continueSession()">
</app-confirmation-popup>
<app-confirmation-popup #session [title]="'Your session expires soon'" [message]="sessionWarning">
</app-confirmation-popup>
